import React from "react";
import PropTypes from "prop-types";

import styles from "../../assets/scss/component/card.module.scss";

const CardFooter = (props) => (
  <div {...props} className={`${styles.cardFooter} ${props.className ?? ""}`}>
    {props.children}
  </div>
);

CardFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default CardFooter;